import { AddressField as CPAddressField } from '@ovotech/energy-cx';
import React, { ComponentProps } from 'react';

type Props = ComponentProps<typeof CPAddressField>;

export const AddressField = ({ id, value, onChange, errors = [] }: Props) => {
  return (
    <fieldset id={id}>
      <div data-testid="address-lookup-manual-address">
        <CPAddressField
          id={id}
          value={value}
          onChange={onChange}
          errors={errors}
        />
      </div>
    </fieldset>
  );
};
